module.exports = [{"name":"FAQ","url":"#","to":"support"},{"name":"Tabela de valores","url":"#","to":"pricing"},{"name":"Termos  e Privacidade","url":"#","to":"terms"}]


//////////////////
// WEBPACK FOOTER
// ./src/database/important_links.json
// module id = Z1Wd
// module chunks = 0